import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetFiltersResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.types';
import React from 'react';
import {FilterAndSortFABView} from '../../../../features/Filters/FilterAndSort/FilterAndSortFABView';
import {useCouponLandingPageFilters} from '../useCouponLandingPageFilters';

interface CouponLandingPageFilterAndSortButtonProps {
  label: string;
}

export const CouponLandingPageFilterAndSortButton: React.FC<
  CouponLandingPageFilterAndSortButtonProps
> = ({label}) => {
  return (
    <DataFetcher
      request={useCouponLandingPageFilters()}
      Error={null}
      View={CouponLandingPageFilterAndSortView}
      viewProps={{label}}
    />
  );
};

const CouponLandingPageFilterAndSortView: React.FC<
  GetFiltersResponse & {label: string}
> = ({appliedFiltersCount, filters, label}) => {
  if (filters.length === 0) {
    return null;
  }
  return <FilterAndSortFABView count={appliedFiltersCount} label={label} />;
};
